import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const GSTEWayBill = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        GST E-Way Bill
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        The GST e-Way Bill is a digital tracking document introduced under the
        Goods and Services Tax to monitor goods in transit, mandatory for
        registered taxable persons transporting consignments valued over Rs.
        50,000.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Application Scope */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Application Scope
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            An e-Way Bill is required when a GST-registered person supplies goods
            worth over Rs. 50,000, transfers goods between godowns with a value
            exceeding Rs. 50,000, or purchases goods from an unregistered person
            with a consignment value above Rs. 50,000.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            LEDGERS simplifies e-Way Bill generation by integrating with GST
            invoices, bills of supply, and customer/supplier accounts, allowing
            seamless creation and sharing with a single click after enabling API
            access on the GST Portal.
          </p>

          {/* Documentation Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Documentation Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The person responsible for goods transportation must carry an
            invoice or bill of supply, delivery challan with an invoice
            reference number from the GST portal, and a copy of the e-Way Bill
            or its number (physically or via RFID on the vehicle) for
            inspection.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For self-managed or hired vehicle transport, the taxable person
            generates the e-Way Bill using Form GST INS-1 on the GST Portal,
            providing details in Part B. If a transporter is involved, they
            generate it based on Part A information, even for consignments below
            Rs. 50,000.
          </p>

          {/* Validity Periods */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Validity Periods
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Validity, updated via Notification No. 12/2018-Central Tax dated
            March 7, 2018, depends on distance and cargo type:
          </p>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              For non-over-dimensional cargo: 1 day for up to 100 km, plus 1
              additional day for every 100 km thereafter.
            </li>
            <li>
              For over-dimensional cargo: 1 day for up to 20 km, plus 1
              additional day for every 20 km thereafter.
            </li>
          </ul>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The validity period starts from the e-Way Bill generation time, with
            each day ending at midnight, and "over-dimensional cargo" refers to
            indivisible units exceeding Central Motor Vehicle Rules, 1989
            limits.
          </p>

          {/* Supporting Details */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Supporting Details
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            To generate an e-Way Bill via LEDGERS, ensure API access is active,
            and provide customer/supplier data and invoice details. Transporters
            must update Part B with vehicle information for accurate tracking.
          </p>

          {/* Final Overview */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Final Overview
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The GST e-Way Bill ensures compliance and efficient goods tracking,
            with LEDGERS offering a user-friendly solution. Adhering to validity
            rules and documentation is crucial for smooth transit and authority
            inspections.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GSTEWayBill;